import { KanbanCardContent } from './KanbanCard';
import { cn, getBoardColorHex } from '../lib/utils';
import type { Board, Card } from '../lib/api';

interface Props {
  card: Card;
  board?: Board;
  onClick?: () => void;
}

/**
 * Command Center card wrapper: adds a board-colored left border + board-name tooltip
 * + shimmer animation while an agent is actively working on the card.
 */
export function CommandCard({ card, board, onClick }: Props) {
  const isLocked = !!(
    card.metadata.claim && new Date(card.metadata.claim.expiresAt) > new Date()
  );
  const boardName = board?.name ?? 'Unknown board';
  const borderColor = getBoardColorHex(board?.settings?.color as string | undefined);

  return (
    <div
      className={cn('relative overflow-hidden rounded-lg', isLocked && 'command-shimmer-bg')}
      style={{ borderLeft: `4px solid ${borderColor}` }}
      title={boardName}
      data-testid="command-card"
      data-board-id={card.boardId}
    >
      <KanbanCardContent card={card} onClick={onClick} isLocked={isLocked} />
      <div className="pointer-events-none absolute bottom-1 right-2 text-[9px] uppercase tracking-wider text-gray-500">
        {boardName}
      </div>
    </div>
  );
}
